var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_vm._t("default"),(_vm.show)?_c('div',{class:['tooltip-content', _vm.chosenPosition]},[_vm._t("tooltip",function(){return [_vm._v(" "+_vm._s(_vm.tooltip)+" ")]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }